import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-powered-by-treefort',
	templateUrl: './powered-by-treefort.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class PoweredByTreefortComponent {}
